import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route

  const currentUser = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img
              src="assets/images/logo.png"
              alt="site logo"
              className="light-logo"
            />
            <img
              src="assets/images/logo-light.png"
              alt="site logo"
              className="dark-logo"
            />
            <img
              src="assets/images/user.png"
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li>
              <NavLink
                to="/"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon
                  icon="solar:home-smile-angle-outline"
                  className="menu-icon"
                />
                <span>Dashboard</span>
              </NavLink>
            </li>


            <li>
              <NavLink
                to="/customer"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon
                  icon="flowbite:users-group-outline"
                  className="menu-icon"
                />
                <span>Customers</span>
              </NavLink>
            </li>

            {currentUser?.roles?.role === 'admin' && (
              <li>
                <NavLink
                  to="/accounts"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon="mdi:bank-outline" className="menu-icon" />
                  <span>Accounts</span>
                </NavLink>
              </li>
            )}
            <li className="dropdown">
              <Link to="#">
                <Icon icon="hugeicons:invoice-03" className="menu-icon" />
                <span>Order Form</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/create-invoice"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Create Order Form
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/invoices"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Order Forms
                  </NavLink>
                </li>




              </ul>
            </li>
            <li className="dropdown">
              <Link to="#">
                <Icon icon="hugeicons:invoice-03" className="menu-icon" />
                <span>Quote</span>
              </Link>
              <ul className="sidebar-submenu">

                <li>
                  <NavLink
                    to="/create-quote"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Create Quote
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/quotes"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Quotes
                  </NavLink>
                </li>



              </ul>
            </li>
            {/* {currentUser?.roles?.role === 'admin' && ( */}
            <li className="dropdown">
              <Link to="#">
                <Icon icon="hugeicons:chart-01" className="menu-icon" />
                <span>Inventory</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/add-stock"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Add new
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/stock-list"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    List
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/uom"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                    UOM
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/color"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-success-main w-auto" />{" "}
                    Colors
                  </NavLink>
                </li>
              </ul>
            </li>
            {/* )} */}


            {/* {currentUser?.roles?.role === 'admin' && (
            <li className="dropdown">
              <Link to="#">
              <Icon icon="hugeicons:chart-01" className="menu-icon" />
                <span>Assets</span>
              </Link>
              <ul className="sidebar-submenu">
               <li>
                  <NavLink
                    to="/add-asset"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Add new
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/list-asset"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    List
                  </NavLink>
                </li>
            
             
              
              </ul>
            </li>
            )} */}



            {/* {currentUser?.roles?.role === 'admin' && (
            <li className="dropdown">
              <Link to="#">
              <Icon icon="hugeicons:customer-service-01" className="menu-icon" />
                <span>Services</span>
              </Link>
              <ul className="sidebar-submenu">
               <li>
                  <NavLink
                    to="/add-service"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Add new
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    List
                  </NavLink>
                </li>
             
              
              </ul>
            </li>
            )} */}

            {/* {currentUser?.roles?.role === 'admin' && (
            <li>
              <NavLink
                to="/list-supplier"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
              <Icon
                 icon="mdi:users"
                  className="menu-icon"
                />
                <span>Suppliers</span>
              </NavLink>
            </li>
            )} */}
            {/* {currentUser?.roles?.role === 'admin' && (
            <li className="dropdown">
              <Link to="#">
              <Icon icon="hugeicons:customer-service-01" className="menu-icon" />
                <span>Purchases</span>
              </Link>
              <ul className="sidebar-submenu">
               <li>
                  <NavLink
                    to="/list-bills"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Bills
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/list-payments"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Payments
                  </NavLink>
                </li>
                
                <li>
                  <NavLink
                    to="/list-po"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    PO
                  </NavLink>
                </li>
             
             
              
              </ul>
            </li>
            )} */}
            {/* {currentUser?.roles?.role === 'admin' && (
           <li className="dropdown">
              <Link to="#">
              <Icon icon="hugeicons:chart-01" className="menu-icon" />
                <span>Expenses</span>
              </Link>
              <ul className="sidebar-submenu">
               <li>
                  <NavLink
                    to="/list-expense"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Expenses
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/expense-category"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Category
                  </NavLink>
                </li>
            
             
              
              </ul>
            </li>
            )} */}

            {/* {currentUser?.roles?.role === 'admin' && (
            <li className="dropdown">
              <Link to="#">
              <Icon icon="mdi:chart-bar" className="menu-icon" />
                <span>Report</span>
              </Link>
              <ul className="sidebar-submenu">
               <li>
                  <NavLink
                    to="/report"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/sales"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Sales Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/purchase"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Purchase Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/assetReport"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Asset Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/expense"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Expense Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/ledgerReport"
                    className={(navData) =>
                      navData.isActive ? "actives-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Ledger Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/profitloss"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Profit & Loss Report
                  </NavLink>
                </li>
               <li>
                  <NavLink
                    to="/accountReport"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Account Report
                  </NavLink>
                </li>
               
              
              </ul>
            </li>
            )} */}



            {/* {currentUser?.roles?.role === 'admin' && (
  <li>
    <NavLink
      to="/select-template"
      className={(navData) => (navData.isActive ? "active-page" : "")}
    >
      <Icon icon="mdi:file-document-edit-outline" className="menu-icon" />
      <span>Order Form Template</span>
    </NavLink>
  </li>
)} */}

            {/* {currentUser?.roles?.role === 'admin' && (
  <li>
    <NavLink
      to="/report"
      className={(navData) => (navData.isActive ? "active-page" : "")}
    >
      <Icon icon="mdi:chart-bar" className="menu-icon" />
      <span>Report</span>
    </NavLink>
  </li>
)} */}



            {currentUser?.roles?.role === 'admin' && (

              <li>
                <NavLink
                  to="/staff"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon
                    icon="mdi:users"
                    className="menu-icon"
                  />
                  <span>Staff</span>
                </NavLink>
              </li>
            )}

            {currentUser?.roles?.role === 'admin' && (
              <li>
                <NavLink
                  to="/company"
                  className={(navData) => (navData.isActive ? "active-page" : "")}
                >
                  <Icon icon="hugeicons:building-02" className="menu-icon" />
                  <span>Company</span>
                </NavLink>
              </li>
            )}

            {/* {currentUser?.roles?.role === 'admin' && (
            <li>
              <NavLink
                to="/policies"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="hugeicons:invoice-01" className="menu-icon" />
                <span>Policies</span>
              </NavLink>
            </li>
            )} */}

            {/* Settings Module */}
            {currentUser?.roles?.role === 'admin' && (
              <li className="dropdown">
                <Link to="#">
                  <Icon icon="hugeicons:settings-01" className="menu-icon" />
                  <span>Settings</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li>
                    <NavLink
                      to="/cities"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                      Cities
                    </NavLink>
                  </li>
                </ul>
              </li>
            )}

          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* ThemeToggleButton */}
                {/* <ThemeToggleButton /> */}

                {/* Notification dropdown end */}
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src="assets/images/user.png"
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {currentUser?.firstName + ' ' + currentUser?.lastName}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          {currentUser?.roles?.role}
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">


                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={(e) => {
                            e.preventDefault();
                            localStorage.removeItem('user');
                            const location = localStorage.getItem('locationID');
                            const token = localStorage.getItem('tokenID')
                            window.location.href = `/sign-in?id=${location}&tk_id=${token}`
                          }}
                        >


                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© 2025 Unisoftwares. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-primary-600">UniSoftwares</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
